export default __webpack_public_path__ + "static/media/placeholder_business01-fr-mobile.5569a2fc.png";